var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3586 1.43713L0.38536 25.6378C0.132954 26.0748 4.6715e-05 26.5706 1.23125e-08 27.0752C-4.66904e-05 27.5799 0.132769 28.0757 0.385094 28.5128C0.63742 28.9499 1.00036 29.3128 1.43743 29.5651C1.87451 29.8175 2.3703 29.9503 2.87499 29.9503H30.8192C31.3239 29.9503 31.8197 29.8175 32.2568 29.5651C32.6939 29.3128 33.0568 28.9499 33.3091 28.5128C33.5615 28.0757 33.6943 27.5799 33.6942 27.0752C33.6942 26.5706 33.5613 26.0748 33.3089 25.6378L19.3371 1.43713C19.0848 1.00019 18.722 0.637346 18.285 0.385077C17.8481 0.132808 17.3524 0 16.8479 0C16.3433 0 15.8477 0.132808 15.4107 0.385077C14.9737 0.637346 14.6109 1.00019 14.3586 1.43713Z",
    fill: "#EE404C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0304 8.90039H16.6659C15.7685 8.90039 15.041 9.62787 15.041 10.5253V18.2919C15.041 19.1893 15.7685 19.9168 16.6659 19.9168H17.0304C17.9278 19.9168 18.6553 19.1893 18.6553 18.2919V10.5253C18.6553 9.62787 17.9278 8.90039 17.0304 8.90039Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8481 26.0771C17.8462 26.0771 18.6553 25.2681 18.6553 24.27C18.6553 23.272 17.8462 22.4629 16.8481 22.4629C15.8501 22.4629 15.041 23.272 15.041 24.27C15.041 25.2681 15.8501 26.0771 16.8481 26.0771Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group (1).e0991792554b2cc6928f51a716255ae3.svg";
export { ForwardRef as ReactComponent };